import React, { useContext, useState } from "react";
import Search from './Search';
import Sort from "./Sort";
import { useAppSelector } from '../redux/hooks'


export default function SearchContainer() {
    
    const searchTitle = useAppSelector((state) => state.pageSettings.searchTitle);

    return (

        <div className="performance-search-container">
            <h2 className="performance-search-header h4-style"> {searchTitle} </h2>
            <Search />
            <Sort />
        </div>

    );
}